/**
 * Gemeinsame Daten-Schnittstelle der Kennzahl-Kachel-Kandidaten (Muster-Vergleich
 * /preline-muster). Alle Kandidaten bekommen dieselben Props; was ein Kandidat nicht
 * darstellen kann, lässt er weg (Teil des Vergleichs, nicht nachbauen).
 */
export type KennzahlTon = "neutral" | "ok" | "warn" | "risiko";

/** Die vier Symbole des Blocks kpi-card-with-icon-and-link (inline SVG dort). */
export type KennzahlIconName = "personen" | "sanduhr" | "zeiger" | "auge";

export interface Kennzahl {
  label: string;
  /** null = Platzhalter „—“ (Kennzahl nicht verfügbar / Gruppe < 5). */
  wert: string | number | null;
  einheit?: string;
  zusatz?: string;
  /** Höchstens zwei Einträge. */
  aufschluesselung?: { label: string; wert: string }[];
  /** Färbt nur die Statusfläche, die der Kandidat selbst hat (Abzeichen/Punkt/Zusatzfarbe). */
  ton?: KennzahlTon;
  trend?: { richtung: "hoch" | "runter" | "gleich"; text: string };
  /** Absprung (Link, kein Button). */
  href?: string;
  icon?: KennzahlIconName;
}

/** Sichtbarer Text der Absprung-Links (Fußzeile in A, Aktion in D). */
export const ABSPRUNG_TEXT = "Details anzeigen";

const ZAHL = new Intl.NumberFormat("de-DE");

/** Wert samt Einheit als Text (geschütztes Leerzeichen vor der Einheit); null bleibt null. */
export function wertText(k: Kennzahl): string | null {
  if (k.wert === null) return null;
  const w = typeof k.wert === "number" ? ZAHL.format(k.wert) : k.wert;
  return k.einheit ? `${w} ${k.einheit}` : w;
}
